module.exports = __webpack_public_path__ + "static/media/delhi.e0944944.jpg";